import { render, staticRenderFns } from "./ShowForm.vue?vue&type=template&id=093490ef&scoped=true"
import script from "./ShowForm.vue?vue&type=script&lang=js"
export * from "./ShowForm.vue?vue&type=script&lang=js"
import style0 from "./ShowForm.vue?vue&type=style&index=0&id=093490ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093490ef",
  null
  
)

export default component.exports